import { useEffect } from 'react';

export default function useTawkTo() {
  useEffect(() => {
    // Skip during react-snap pre-rendering (runs on port 45678)
    if (typeof window !== 'undefined' && window.location.port === '45678') return;
    if (document.getElementById('tawk-to-script')) return;

    // Delay loading to avoid hydration mismatch
    const timer = setTimeout(() => {
      (window as any).Tawk_API = (window as any).Tawk_API || {};
      (window as any).Tawk_LoadStart = new Date();
      const s1 = document.createElement('script');
      s1.id = 'tawk-to-script';
      s1.async = true;
      s1.src = 'https://embed.tawk.to/6a2a64550514041c3544c50c/1jqqpfsbd';
      s1.charset = 'UTF-8';
      s1.setAttribute('crossorigin', '*');

      document.body.appendChild(s1);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);
}
